<template>
  <SoPageWithHeader title="Newsfeed Management">
    <NewsfeedEnvironmentWarning />
    <AdminNewsfeedListTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import AdminNewsfeedListTable from "./components/AdminNewsfeedListTable.vue"
  import NewsfeedEnvironmentWarning from "./components/NewsfeedEnvironmentWarning.vue"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      AdminNewsfeedListTable,
      NewsfeedEnvironmentWarning,
    },
  })
</script>
